module.exports = __webpack_public_path__ + "static/media/icon-lifeplan.3e099f60.svg";